<template>
    <div class="content payment-method-wrapper">
      <h4 class="title">
        Payment Method
      </h4>

      <div>
        <div v-if="billingMethod === 'manual'">
          Monthly invoice (net 30)*
        </div>

        <div v-else-if="billingMethod === 'automatic'">
          Automatic payment via credit card
          <div class="card-info">
            <font-awesome-icon :icon="cardIcon" size="2x" />
              {{ accountInfo.company.billing.last4 }}

            <div class="expiration-date">
              Expiration:
              {{ accountInfo.company.billing.exp_month }}/{{ accountInfo.company.billing.exp_year }}
            </div>
          </div>
        </div>

        <div v-else>
          No payment method is set.
        </div>

        <div class="change-payment-method">
        <button v-if="billingMethod" @click="toggleChangeMethodModal" class="button is-info is-small">Change payment method</button>
        <button v-else @click="toggleChangeMethodModal" class="button is-info is-small">Setup a payment method</button>
          <br/>
        <template v-if="billingMethod === 'manual'"> to automatic CC payment</template>
        <template v-else-if="billingMethod === 'automatic'">to monthly invoice (net 30)*</template>
        </div>

      </div>


      <div class="disclaimer">* Monthly invoice process fees apply</div>
      <payment-method-modal :show.sync="showChangMethodModal"></payment-method-modal>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { isEmpty } from 'lodash-es'
import PaymentMethodModal from '@/components/ModalPaymentMethod'

export default {
  name: 'PaymentMethod',

  computed: {
    ...mapState('company', ['currentCompanyInfo']),
    ...mapGetters('user', ['accountInfo']),

    billingMethod() {
      return this.currentCompanyInfo.companyBillingMethod
    },

    hasBillingInfo() {
      return !isEmpty(this.currentCompanyInfo.billing)
    },

    cardIcon() {
      const brand = (this.accountInfo.company.billing.brand || '').toLocaleLowerCase()
      // brand. Can be American Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown

      let iconName = 'cc-stripe'
      if (brand === 'american express') {
        iconName = 'cc-amex'
      } else if (brand === 'diners club') {
        iconName = 'cc-diners-club'
      } else if (brand === 'discover') {
        iconName = 'cc-discover'
      } else if (brand === 'jcb') {
        iconName = 'cc-jcb'
      } else if (brand === 'mastercard') {
        iconName = 'cc-mastercard'
      } else if (brand === 'visa') {
        iconName = 'cc-visa'
      }

      return ['fab', iconName]
    }
  },

  data() {
    return {
      showChangMethodModal: false
    }
  },

  components: {
    PaymentMethodModal
  },

  methods: {
    toggleChangeMethodModal() {
      this.showChangMethodModal = !this.showChangMethodModal
    }
  }
}
</script>

<style scoped lang="scss">
.payment-method-wrapper {
  position: relative;
  height: 100%;
}

ul {
  list-style: none;
}

.is-disabled {
  font-size: 0.8rem;
}

.card-info {
  margin-top: 10px;
  margin-left: 15px;

  .expiration-date {
    font-size: 0.8rem;
  }
}

.change-payment-method {
  position: absolute;
  bottom: 200px;
  font-size: 0.8rem;
  text-align: center;
  width: 100%;
}

.disclaimer {
  position: absolute;
  bottom: 0;
  font-size: 0.8rem;
}
</style>
